import { render, staticRenderFns } from "./CompanyLetterTemplate.vue?vue&type=template&id=d4a2d3f4&scoped=true"
import script from "./CompanyLetterTemplate.vue?vue&type=script&lang=js"
export * from "./CompanyLetterTemplate.vue?vue&type=script&lang=js"
import style0 from "./CompanyLetterTemplate.vue?vue&type=style&index=0&id=d4a2d3f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a2d3f4",
  null
  
)

export default component.exports